import React from 'react';
import styled from 'styled-components';
import { useIsMobile } from '../../shared/theme';

const Hr = styled.hr`
  margin: 20px 0;
  width: 100%;
  border: none;
  border-bottom: 1px solid #d7dfe7;
`;

export default function FullWidthHrMobile() {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  return <Hr />;
}
